import type { IconData } from '@stacksjs/iconify-core'

export const columns: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 48H40a24.03 24.03 0 0 0-24 24v376a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V72a24.03 24.03 0 0 0-24-24m-8 32v64H48V80ZM48 176h192v264H48Zm224 264V176h192v264Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default columns
